module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/73/assets/images/8963a017c8e772a3dbfa67555c73be41.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_step_2.svg
// module id = XP6K
// module chunks = 0